import {
  useListReports,
  useListProvidersByOrganization,
  useListSubmissionsBySite,
  useListSites,
  useListRemittanceBySite,
} from 'api/resource';
import { useListPayors } from 'api/resource/payor';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useAdminReportManagementData = () => {
  const { organizationID, id: siteID } = useCurrentSiteStore();

  const reportsResult = useListReports({});

  const sitesResult = useListSites({ isAdmin: true });

  const providersResult = useListProvidersByOrganization({ organizationID });

  const submissionsResult = useListSubmissionsBySite({ siteID });

  const remittanceResult = useListRemittanceBySite({ siteID });

  const payorsResult = useListPayors();

  const isLoading = [
    reportsResult.isLoading,
    sitesResult.isLoading,
    providersResult.isLoading,
    submissionsResult.isLoading,
    remittanceResult.isLoading,
    payorsResult.isLoading,
  ].some((loading) => loading);

  const isError = [
    reportsResult.isError,
    sitesResult.isError,
    providersResult.isError,
    submissionsResult.isError,
    remittanceResult.isError,
    payorsResult.isError,
  ].some((error) => error);

  const isFetching = [
    reportsResult.isFetching,
    sitesResult.isFetching,
    providersResult.isFetching,
    submissionsResult.isFetching,
    remittanceResult.isFetching,
    payorsResult.isFetching,
  ].some((fetching) => fetching);

  const errorMessage = [
    reportsResult.error?.message,
    sitesResult.error?.message,
    providersResult.error?.message,
    submissionsResult.error?.message,
    remittanceResult.error?.message,
    payorsResult.error?.message,
  ].find((message) => message);

  return {
    reports: reportsResult.data || [],
    sites: sitesResult.data || [],
    providers: providersResult.data || [],
    submissions: submissionsResult.data || [],
    remittances: remittanceResult.data || [],
    payors: payorsResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports: reportsResult.refetch,
  };
};
